import { Component } from '@angular/core';
import { UieventhubService } from '../uieventhub/uieventhub.service';
import { DatastoreService } from '../datastore/datastore.service';
import { SessionHelper } from '../sessionHelper';
import { Auth } from 'aws-amplify';
import { Router } from '@angular/router';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-refreshsession',
  templateUrl: './refreshsession.component.html',
  styleUrl: './refreshsession.component.css'
})
export class RefreshsessionComponent {

  constructor(
    private uievent:UieventhubService, 
    private datastore:DatastoreService,
    private router:Router
  ) { }

  refreshSession() {
   //console.log('Session refreshed');
    window.location.reload();
  }
  logOut() {
    this.uievent.setshowchatcollapse(false);
    this.datastore.clearData(); 
    SessionHelper.clear();

    Auth.signOut()
    .then(() => {
      this.router.navigate(['/login']);
    });
  }
}
